export default __webpack_public_path__ + "static/media/carousel-image5.b68ad5a2.jpg";